import { hasDirectoryTraversal } from 'notable-common';
import { ExternalDocumentPacketExportReason } from 'primary-schema';
import { z } from 'zod';

export const ExportExternalDocumentPacketBlockConfigSchema = z.object({
  externalDocumentPacket: z.object({
    sourceBlockName: z.string(),
  }),
  exportReason: z.enum(ExternalDocumentPacketExportReason),
  filePath: z
    .string()
    .optional()
    .refine((filePath) => !hasDirectoryTraversal(filePath), {
      message: 'Directory traversal attempts (..) are not allowed in file paths',
    }),
});

export type ExportExternalDocumentPacketBlockConfig = z.infer<
  typeof ExportExternalDocumentPacketBlockConfigSchema
>;
